// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__F1Ko8","log":"ModalInventoryLogs_log__1dTBx","date":"ModalInventoryLogs_date__3nrVj","userName":"ModalInventoryLogs_userName__3mu3f"};